var _excluded = ["title", "titleProps", "text", "readMore", "duration", "easing", "readMoreHeight", "link", "linkText", "target", "secondaryLink", "secondaryLinkText", "secondaryTarget", "buttonClassName", "buttonPrimary", "secondaryButtonPrimary", "secondaryButtonClassName", "className", "children"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import AnimateHeight from 'react-animate-height';
import c from 'classnames';
import TitleWithText from '../../components/TitleWithText';
import { Button } from '../../components';
var Text = function Text(_ref) {
  var title = _ref.title,
    titleProps = _ref.titleProps,
    text = _ref.text,
    readMore = _ref.readMore,
    _ref$duration = _ref.duration,
    duration = _ref$duration === void 0 ? 333 : _ref$duration,
    _ref$easing = _ref.easing,
    easing = _ref$easing === void 0 ? 'cubic-bezier(0.65, 0, 0.35, 1)' : _ref$easing,
    _ref$readMoreHeight = _ref.readMoreHeight,
    readMoreHeight = _ref$readMoreHeight === void 0 ? 0 : _ref$readMoreHeight,
    link = _ref.link,
    linkText = _ref.linkText,
    _ref$target = _ref.target,
    target = _ref$target === void 0 ? '_self' : _ref$target,
    secondaryLink = _ref.secondaryLink,
    secondaryLinkText = _ref.secondaryLinkText,
    _ref$secondaryTarget = _ref.secondaryTarget,
    secondaryTarget = _ref$secondaryTarget === void 0 ? '_self' : _ref$secondaryTarget,
    buttonClassName = _ref.buttonClassName,
    _ref$buttonPrimary = _ref.buttonPrimary,
    buttonPrimary = _ref$buttonPrimary === void 0 ? true : _ref$buttonPrimary,
    _ref$secondaryButtonP = _ref.secondaryButtonPrimary,
    secondaryButtonPrimary = _ref$secondaryButtonP === void 0 ? true : _ref$secondaryButtonP,
    secondaryButtonClassName = _ref.secondaryButtonClassName,
    className = _ref.className,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    readMoreOpened = _useState2[0],
    setReadMoreOpened = _useState2[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var classes = c('Text', className);
  var readMoreClasses = c('Text__read_more', {
    'Text__read_more--open': readMoreOpened
  });
  var buttonClasses = c('Text__link', buttonClassName);
  var secondaryButtonClasses = c('Text__link__secondary', secondaryButtonClassName);
  return /*#__PURE__*/React.createElement("div", {
    className: classes
  }, /*#__PURE__*/React.createElement(TitleWithText, _extends({
    title: title,
    text: text,
    titleProps: titleProps
  }, props)), readMore && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: readMoreClasses
  }, /*#__PURE__*/React.createElement(AnimateHeight, {
    duration: duration,
    easing: easing,
    height: readMoreOpened ? 'auto' : readMoreHeight
  }, /*#__PURE__*/React.createElement(TitleWithText, {
    text: readMore
  }))), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "Text__read_more__button",
    onClick: function onClick() {
      return setReadMoreOpened(!readMoreOpened);
    }
  }, readMoreOpened ? t('organisms.text.read_less') : t('organisms.text.read_more'))), (link || secondaryLink) && /*#__PURE__*/React.createElement("div", {
    className: "Text__links"
  }, link && /*#__PURE__*/React.createElement(Button, {
    className: buttonClasses,
    href: link,
    target: target,
    rel: "noreferrer",
    primary: buttonPrimary
  }, /*#__PURE__*/React.createElement("span", null, linkText)), secondaryLink && /*#__PURE__*/React.createElement(Button, {
    className: secondaryButtonClasses,
    href: secondaryLink,
    target: secondaryTarget,
    primary: secondaryButtonPrimary,
    inverted: true,
    rel: "noreferrer"
  }, /*#__PURE__*/React.createElement("span", null, secondaryLinkText))), children);
};
export default Text;